export default __webpack_public_path__ + "static/media/pa.1e1e400e.png";